import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import jsPDF from 'jspdf';
import { PrintDetail } from 'src/app/Models/print/print-detail';
import { PrintHeader } from 'src/app/Models/print/print-header';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';

@Component({
  selector: 'app-print-boleta',
  templateUrl: './print-boleta.component.html',
  styleUrls: ['./print-boleta.component.css']
})
export class PrintBoletaComponent implements OnInit {

  constructor(private title: Title, private data: DataService, private notify: NotifyService, private auth: AuthService, private route: ActivatedRoute, private router:Router) { }
  facturaId: string = '0';
  public cabecera: PrintHeader = new PrintHeader();
  public detalle: PrintDetail[] = [];
  @ViewChild('pagina', null) public pagina: ElementRef;
  async ngOnInit() {
    this.title.setTitle('Impresión de Boleta');
    this.facturaId = this.route.snapshot.paramMap.get('facturaId');
    console.log(this.facturaId);
    await this.getFactura();
  }
  printer() {
    const doc = new jsPDF();
    console.log(this.pagina.nativeElement);
    doc.text("Hello world!", 10, 10);
    doc.save("a4.pdf");
  }

  async getFactura() {
    await this.data.Print(this.facturaId).then(r => {
      console.log(r);
      if (r != null) {
        this.cabecera = r.cabezera;
        console.log(this.cabecera);
        
        //this.cabecera.fac_direccion = this.cabecera.fac_direccion.replace('\r\n', '<br>');
        this.detalle = r.detalle;
        console.log(this.detalle);
      }
    }).catch(e => { console.log(e) });
  }
  public isbutton: Boolean = true;
  click:boolean = false;
  // async print() {
  //     const doc = new jsPDF({ orientation: 'p', unit: 'px', format: [332, this.pagina.nativeElement.offsetHeight + 80] });
  //     doc.setDisplayMode('');
  //     let html = this.pagina.nativeElement;
  //     await doc.html(this.pagina.nativeElement, { margin: 0, x: 0, y: 0 });
  //     var blobPDF =  new Blob([  ], { type : 'application/pdf'});
  //     var blobUrl = URL.createObjectURL(blobPDF);  //<--- THE ERROR APPEARS HERE
  //     console.log(blobUrl);
  //     window.open(blobUrl);  // will open a new tab
  //     doc.autoPrint({variant: 'non-conform'});
  //     doc.save("PED-"+this.facturaId+".pdf");
  // }
  async print() {
    // Ajustar el tamaño del documento: 80 mm de ancho (226.77 px) por la altura que necesites
    const doc = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: [80, this.pagina.nativeElement.offsetHeight] // 80 mm de ancho y altura dinámica
    });
  
    // Renderiza el HTML en el PDF
    await doc.html(this.pagina.nativeElement, {
      margin: 0,
      x: 0,
      y: 0
    });
  
    // Obtener el PDF como Blob
    const pdfData = doc.output('blob');
    const blobUrl = URL.createObjectURL(pdfData);
    
    // Abrir el PDF en una nueva pestaña
    window.open(blobUrl);
  
    // Imprimir automáticamente
    doc.autoPrint({ variant: 'non-conform' });
  
    // Guardar el PDF
    //doc.save("PED-" + this.facturaId + ".pdf");
  }
  
  mouseenter() {
    if(!this.click){
      this.isbutton = true;
    } else{
      this.isbutton = false;
    }
  }

  back(){
    window.history.back();
  }

}
